/** Search params used in the site types API. */
export const searchParametersSiteTypesApi = {
    MANAGER: 'client__id',
}
